
import { lazy, Suspense } from "react";
import { LoadingSpinner } from "@/components/ui/loading-spinner";
import { Navigate } from "react-router-dom";

// Lazy load resource pages
const IncidentResponsePlanTemplate = lazy(() => import("@/pages/resources/downloads/IncidentResponsePlanTemplate"));
const HipaaReadinessWhitePaper = lazy(() => import("@/pages/resources/downloads/HipaaReadinessWhitePaper"));
const ManagedGrcWhitePaper = lazy(() => import("@/pages/resources/downloads/ManagedGrcWhitePaper"));
const PenetrationTestWhitePaper = lazy(() => import("@/pages/resources/downloads/PenetrationTestWhitePaper"));
const CybersecurityRoadmapWhitePaper = lazy(() => import("@/pages/resources/downloads/CybersecurityRoadmapWhitePaper"));

// Main resources page for browsing all resources
const ResourceCenter = lazy(() => import("@/pages/resources/ResourceCenter"));

// Define the routes for resources
export const resourcesRoutes = [
  {
    path: "/resources",
    element: (
      <Suspense fallback={<LoadingSpinner fullPage />}>
        <ResourceCenter />
      </Suspense>
    ),
  },
  // Security guide redirects implemented directly in routes (client-side) for better performance
  {
    path: "/resources/security-guide",
    element: <Navigate to="/tools/security-field-guide" replace />,
  },
  {
    path: "/resources/security-guide/assessment",
    element: <Navigate to="/tools/security-field-guide/assessment" replace />,
  },
  {
    path: "/resources/security-guide/roadmap",
    element: <Navigate to="/tools/security-field-guide/roadmap" replace />,
  },
  {
    path: "/resources/security-guide/resources",
    element: <Navigate to="/tools/security-field-guide/resources" replace />,
  },
  {
    path: "/resources/security-guide/controls",
    element: <Navigate to="/tools/security-field-guide/controls" replace />,
  },
  {
    path: "/resources/security-guide/report",
    element: <Navigate to="/tools/security-field-guide/report" replace />,
  },
  {
    path: "/resources/security-guide/dashboard",
    element: <Navigate to="/tools/security-field-guide/dashboard" replace />,
  },
  // Resource download pages
  {
    path: "/resources/incident-response-plan-template",
    element: (
      <Suspense fallback={<LoadingSpinner fullPage />}>
        <IncidentResponsePlanTemplate />
      </Suspense>
    ),
  },
  {
    path: "/resources/hipaa-readiness-white-paper",
    element: (
      <Suspense fallback={<LoadingSpinner fullPage />}>
        <HipaaReadinessWhitePaper />
      </Suspense>
    ),
  },
  {
    path: "/resources/managed-grc-white-paper",
    element: (
      <Suspense fallback={<LoadingSpinner fullPage />}>
        <ManagedGrcWhitePaper />
      </Suspense>
    ),
  },
  {
    path: "/resources/penetration-test-white-paper",
    element: (
      <Suspense fallback={<LoadingSpinner fullPage />}>
        <PenetrationTestWhitePaper />
      </Suspense>
    ),
  },
  {
    path: "/resources/cybersecurity-roadmap-white-paper",
    element: (
      <Suspense fallback={<LoadingSpinner fullPage />}>
        <CybersecurityRoadmapWhitePaper />
      </Suspense>
    ),
  }
];
